import { Stack } from "@mui/material";
import React from "react";

import { HubIcon, StationHookFormSelect } from "../../components";
import { StyledCell, StyledStack } from "./styles";

const ReworkStationTableRow = ({ idx, item, remove = () => {} }) => {
  const prefix = `stations.${idx}`;

  return (
    <Stack backgroundColor="hubColors.white">
      <StyledStack>
        <StyledCell direction="row" gap="0px">
          <HubIcon icon="MoreVertical" size="10px" />
          <HubIcon icon="MoreVertical" size="10px" sx={{ ml: "-7px" }} />
        </StyledCell>
        <StationHookFormSelect
          label={null}
          name={`${prefix}.stationId`}
          defaultValue={item?.stationId}
          departmentId={4}
          required
        />
        <StyledCell onClick={() => remove(idx)}>
          <HubIcon icon="X" size="10px" />
        </StyledCell>
      </StyledStack>
    </Stack>
  );
};

export default ReworkStationTableRow;
